import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 12,
  viewboxHeight: 12,
};

export const CallerMicUnmutedIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M3.07614 6.47784C3.56432 6.33808 4.07102 6.28311 4.57445 6.31301C4.82044 6.32763 4.99997 6.54041 4.99997 6.78683V9.39972C4.99997 9.67586 4.77611 9.89972 4.49997 9.89972H0.299776C0.253111 9.90066 0.20676 9.89032 0.16501 9.86945C0.123284 9.84854 0.086757 9.81752 0.0595417 9.7796C0.031789 9.74245 0.0131509 9.69926 0.0048542 9.65363C-0.00347018 9.60782 -0.00134012 9.56062 0.0116901 9.51593C0.225601 8.79265 0.618617 8.13483 1.15427 7.60382C1.68991 7.07283 2.35105 6.68545 3.07614 6.47784Z"
        fill="currentFill"
      />
      <path
        d="M1.35 2.85C1.35 3.60587 1.65027 4.33078 2.18475 4.86525C2.71922 5.39973 3.44413 5.7 4.2 5.7C4.95587 5.7 5.68078 5.39973 6.21525 4.86525C6.74973 4.33078 7.05 3.60587 7.05 2.85C7.05 2.09413 6.74973 1.36922 6.21525 0.834746C5.68078 0.300267 4.95587 0 4.2 0C3.44413 0 2.71922 0.300267 2.18475 0.834746C1.65027 1.36922 1.35 2.09413 1.35 2.85Z"
        fill="currentFill"
      />
      <path
        d="M10 8.66667C10.4969 8.66557 10.9732 8.46767 11.3246 8.11628C11.676 7.76488 11.8739 7.28861 11.875 6.79167V3.875C11.875 3.37772 11.6775 2.90081 11.3258 2.54917C10.9742 2.19754 10.4973 2 10 2C9.50272 2 9.02581 2.19754 8.67417 2.54917C8.32254 2.90081 8.125 3.37772 8.125 3.875V6.79167C8.1261 7.28861 8.324 7.76488 8.67539 8.11628C9.02678 8.46767 9.50306 8.66557 10 8.66667Z"
        fill="currentFill"
      />
      <path
        d="M12.9167 5.33334C12.8062 5.33334 12.7002 5.37724 12.622 5.45538C12.5439 5.53352 12.5 5.6395 12.5 5.75001V6.79168C12.5 7.45472 12.2366 8.0906 11.7678 8.55944C11.2989 9.02828 10.663 9.29168 10 9.29168C9.33696 9.29168 8.70107 9.02828 8.23223 8.55944C7.76339 8.0906 7.5 7.45472 7.5 6.79168V5.75001C7.5 5.6395 7.4561 5.53352 7.37796 5.45538C7.29982 5.37724 7.19384 5.33334 7.08333 5.33334C6.97283 5.33334 6.86685 5.37724 6.78871 5.45538C6.71056 5.53352 6.66667 5.6395 6.66667 5.75001V6.79168C6.66646 7.58851 6.95171 8.35905 7.47072 8.96367C7.98974 9.56829 8.70817 9.96699 9.49583 10.0875C9.51978 10.0914 9.54162 10.1035 9.5576 10.1217C9.57357 10.14 9.58267 10.1633 9.58333 10.1875V11.5833C9.58333 11.6938 9.62723 11.7998 9.70537 11.878C9.78351 11.9561 9.88949 12 10 12C10.1105 12 10.2165 11.9561 10.2946 11.878C10.3728 11.7998 10.4167 11.6938 10.4167 11.5833V10.1875C10.4173 10.1633 10.4264 10.14 10.4424 10.1217C10.4584 10.1035 10.4802 10.0914 10.5042 10.0875C11.2918 9.96699 12.0103 9.56829 12.5293 8.96367C13.0483 8.35905 13.3335 7.58851 13.3333 6.79168V5.75001C13.3333 5.6395 13.2894 5.53352 13.2113 5.45538C13.1332 5.37724 13.0272 5.33334 12.9167 5.33334Z"
        fill="currentFill"
      />
    </SVGLoader>
  );
};

export default CallerMicUnmutedIcon;
